<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" md="6" class="pt-0">
        <v-row>
          <v-col cols="12">
            <general-info
              :location="location"
            ></general-info>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" md="6" class="pt-0">
        <v-row>
          <v-col cols="12">
          </v-col>
          <v-col cols="12">
            <coil-settings
              :coilSettings="getCoilSettings(location.coil_settings)"
            ></coil-settings>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <div v-if="fetchingData" class="d-flex justify-center">
      <v-progress-circular :size="50" indeterminate color="primary"></v-progress-circular>
    </div>

    <div v-else>
      <location-product-list
        :products="products"
        :allProducts="allProducts"
        :productListFolder="location.product_list.folder"
        :coilSettings="getCoilSettings(location.coil_settings)"
        :locationsData="locationsData"
      ></location-product-list>

      <v-row>
        <v-col cols="12" v-for="locationData in locationsData" :key="locationData.id">
          <empty-product
            :coils="emptyCoils[locationData.id]"
            :allProducts="allProducts"
            :locationData="locationData"
          ></empty-product>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
  import LocationProductList from '@/components/Common/Rental/Locations/Products/LocationProductList'
  import GeneralInfo from '@/components/Common/Rental/Locations/Information/GeneralInfo'
  import CoilSettings from '@/components/Common/Rental/Locations/Information/CoilSettings'
  import EmptyProduct from '@/components/Common/Rental/Locations/Products/EmptyProduct'

  import coilSettingMixin from '@/mixins/coilSetting'
  import groupByMixin from '@/mixins/groupBy'

  export default {
    components: {
      LocationProductList,
      GeneralInfo,
      CoilSettings,
      EmptyProduct
    },

    mixins: [
      coilSettingMixin,
      groupByMixin
    ],

    props: {
      location: Object
    },

    data () {
      return {
        fetchingData: false,
        products: [],
        allProducts: [],
        locationsData: {},
        locationColors: ['green', 'blue', 'amber', 'lime', 'blue-grey', 'deep-purple', 'cyan', 'brown', 'pink', 'yellow']
      }
    },

    watch: {
      location: function (val) {
        this.reload()
      }
    },

    created () {
      if (this.location) {
        this.reload()
      }
    },

    computed: {
      isMultipleLocation () {
        return this.location.store && this.location.store.locations.length > 1
      },

      emptyCoils () {
        let emptyCoils = {}
        if (this.isMultipleLocation) {
          this.location.store.locations.map((storeLocation) => {
            emptyCoils[storeLocation.id] = storeLocation.vending_machine.unoccupied_coils.map((coil) => {
              return storeLocation.coils[coil.label]
            })
          })
        } else {
          emptyCoils[this.location.id] = this.location.vending_machine.unoccupied_coils.map((coil) => {
            return this.location.coils[coil.label]
          })
        }
        return emptyCoils
      }
    },

    mounted () {
    },

    methods: {
      reload () {
        this.fetchingData = true
        let products = []

        let counter = 0
        this.locationsData[this.location.id] = this.getLocationDetail(this.location)
        this.locationsData[this.location.id].color = this.locationColors[counter]
        counter++
        products = this.location.products

        if (this.isMultipleLocation) {
          this.location.store.locations
            .filter((storeLocation) => { return storeLocation.id !== this.location.id })
            .map((storeLocation) => {
              this.locationsData[storeLocation.id] = this.getLocationDetail(storeLocation)
              this.locationsData[storeLocation.id].color = this.locationColors[counter]
              counter++
              products = products.concat(storeLocation.products)
            })
        }

        products.sort(function (a, b) {
          if (a.locationId !== b.locationId) {
            return a.locationId - b.locationId
          }
          return a.first_coil - b.first_coil
        })

        this.products = this.groupBy(products, 'id')
        this.fetchingData = false
      },

      getLocationDetail (location) {
        return {
          id: location.id,
          name: location.name,
          ssh_port: location.vending_machine.ssh_port,
          engagement: location.engagement,
          replenishment_cycle: parseFloat(location.replenishment_cycle),
          machine_model: location.vending_machine.model,
          product_list_folder: location.product_list.folder,
          coil_settings: coilSettingMixin.methods.getCoilSettings(location.coil_settings)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Common/Rental/Locations/ProductList.vue